var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoNative = function SvgInfoNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68 0 0 2.68 0 6s2.68 6 6 6 6-2.68 6-6-2.68-6-6-6Zm.66 2.43a.87.87 0 1 1-.001 1.741.87.87 0 0 1 .001-1.741Zm.84 6.03c-.63.73-2.74 1.73-3.12.62-.15-.43 1.12-3.87 1.01-4.05-.07-.12-.25-.23-.4-.33-.19-.13 2.08-.57 1.84.25-.17.58-1.01 3.08-1.14 3.49-.14.46.26.44.47.33.06-.03.72-.43 1.07-.67.53-.36.51.11.29.36H7.5Z",
    fill: "#666"
  })));
};
export default SvgInfoNative;